import { render, staticRenderFns } from "./CustomerFollowLogDetails.vue?vue&type=template&id=2c8e9be0"
import script from "./CustomerFollowLogDetails.vue?vue&type=script&lang=js"
export * from "./CustomerFollowLogDetails.vue?vue&type=script&lang=js"
import style0 from "./CustomerFollowLogDetails.vue?vue&type=style&index=0&id=2c8e9be0&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports